webpackJsonp([3],{

/***/ "B3iM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_unistore_preact__ = __webpack_require__("o6ac");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_unistore_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_unistore_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_common__ = __webpack_require__("2UA+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_i18n__ = __webpack_require__("LnyB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style_css__ = __webpack_require__("NZ8y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__button__ = __webpack_require__("SUer");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_api__ = __webpack_require__("XeJm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_postMessage__ = __webpack_require__("em/f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_constants__ = __webpack_require__("hafV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_cache__ = __webpack_require__("WsRd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_cache___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__common_cache__);


function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure undefined"); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var CodeIntegration = function (_Component) {
  _inherits(CodeIntegration, _Component);

  function CodeIntegration(props) {
    _classCallCheck(this, CodeIntegration);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.onTestIntigration = function (event) {
      event.preventDefault();
      __WEBPACK_IMPORTED_MODULE_2__common_common__["a" /* default */].log('onClick', 'Get API Keys');
      var postMessageObj = { body: { resultInfo: { resultCode: '006' } } };
      Object(__WEBPACK_IMPORTED_MODULE_7__common_postMessage__["a" /* postMessageOnParentWindow */])(postMessageObj);
    };

    _this.copyToClipboard = function (label) {
      if (_this.state.isJSCodeCopied === false) {
        _this.setState({ isJSCodeCopied: true });
        __WEBPACK_IMPORTED_MODULE_6__common_api__["a" /* default */].updateCheckoutPreference({ prefName: label, prefValue: 'Y' }).then(function () {
          //
        }).catch(function () {
          _this.setState({ isJSCodeCopied: false });
        });
      }

      __WEBPACK_IMPORTED_MODULE_2__common_common__["a" /* default */].log('onClick', 'Code Copied');

      try {
        var copyText = document.getElementById('checkout-code');
        var selection = window.getSelection();
        var range = document.createRange();

        range.selectNodeContents(copyText);
        selection.removeAllRanges();
        selection.addRange(range);

        document.execCommand('copy');
        selection.removeAllRanges();

        _this.updateProperties();
      } catch (e) {
        _this.updateProperties();
      }
    };

    _this.updateProperties = function () {
      if (_this.state.isCoppied === false) {
        _this.setState({ isCoppied: true });
        setTimeout(function () {
          _this.setState({ isCoppied: false });
        }, 5000);
      }
    };

    var mid = Object(__WEBPACK_IMPORTED_MODULE_9__common_cache__["get"])(__WEBPACK_IMPORTED_MODULE_8__utils_constants__["n" /* default */].MID);
    var apiHost = __WEBPACK_IMPORTED_MODULE_8__utils_constants__["n" /* default */].BASE_URL;
    _this.state = { isJSCodeCopied: false, isCoppied: false, MID: mid, apiHost: apiHost };
    return _this;
  }

  CodeIntegration.prototype.render = function render(_ref, _ref2) {
    var isCoppied = _ref2.isCoppied,
        MID = _ref2.MID,
        apiHost = _ref2.apiHost;

    _objectDestructuringEmpty(_ref);

    var code = '<script type="application/javascript" crossorigin="anonymous" src="' + apiHost + '/checkoutjs/merchants/' + MID + '.js" onload="onScriptLoad();"></script>\n<script>\n    function onScriptLoad(){\n        var config = {\n         "root": "",\n         "flow": "DEFAULT",\n         "data": {\n          "orderId": "" /* update order id */,\n          "token": "" /* update token value */,\n          "tokenType": "TXN_TOKEN",\n          "amount": "" /* update amount */\n         },\n         "handler": {\n            "notifyMerchant": function(eventName,data){\n              console.log("notifyMerchant handler function called");\n              console.log("eventName => ",eventName);\n              console.log("data => ",data);\n            } \n          }\n        };\n\n        if(window.Paytm && window.Paytm.CheckoutJS){\n            window.Paytm.CheckoutJS.onLoad(function excecuteAfterCompleteLoad() {\n                // initialze configuration using init method \n                window.Paytm.CheckoutJS.init(config).then(function onSuccess() {\n                   // after successfully update configuration invoke checkoutjs\n                   window.Paytm.CheckoutJS.invoke();\n                }).catch(function onError(error){\n                    console.log("error => ",error);\n                });\n            });\n        } \n    }\n</script>\n';
    return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'div',
      { className: '' + __WEBPACK_IMPORTED_MODULE_4__style_css___default.a['code-int'] },
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'h5',
        { className: 'theme-heading' },
        Object(__WEBPACK_IMPORTED_MODULE_3__utils_i18n__["b" /* locale */])('step2.title')
      ),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'p',
        { className: '' + __WEBPACK_IMPORTED_MODULE_4__style_css___default.a['sub-txt'] },
        Object(__WEBPACK_IMPORTED_MODULE_3__utils_i18n__["b" /* locale */])('step2.desc')
      ),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'div',
        { className: '' + __WEBPACK_IMPORTED_MODULE_4__style_css___default.a['code-inner'] },
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          'div',
          { className: '' + __WEBPACK_IMPORTED_MODULE_4__style_css___default.a['code-block-wrap'] },
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            'div',
            { className: '' + __WEBPACK_IMPORTED_MODULE_4__style_css___default.a['code-block'] },
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('input', { type: 'text', value: code, style: 'display: none' }),
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
              'p',
              { className: '' + __WEBPACK_IMPORTED_MODULE_4__style_css___default.a['code-txt'], id: 'checkout-code' },
              Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                'pre',
                null,
                code
              )
            ),
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
              'div',
              { className: '' + __WEBPACK_IMPORTED_MODULE_4__style_css___default.a['code-btn-block'] },
              Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                'div',
                {
                  className: __WEBPACK_IMPORTED_MODULE_4__style_css___default.a['copy-code'] + ' bold',
                  onClick: this.copyToClipboard.bind(this, 'isJSCheckoutIntegrated')
                },
                Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('img', {
                  className: '' + __WEBPACK_IMPORTED_MODULE_4__style_css___default.a['copy-icon'],
                  src: __WEBPACK_IMPORTED_MODULE_2__common_common__["a" /* default */].getStaticPath() + '/assets/images/ic-content-copy.svg',
                  alt: ''
                }),
                Object(__WEBPACK_IMPORTED_MODULE_3__utils_i18n__["b" /* locale */])('step2.copy')
              ),
              Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
                'div',
                { className: __WEBPACK_IMPORTED_MODULE_4__style_css___default.a['code-copied'] + ' ' + (isCoppied ? __WEBPACK_IMPORTED_MODULE_4__style_css___default.a.copied : '') + ' ' },
                'Code Copied'
              )
            )
          )
        ),
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          'div',
          { className: '' + __WEBPACK_IMPORTED_MODULE_4__style_css___default.a['ser-int'] },
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            'h5',
            { className: 'theme-heading' },
            Object(__WEBPACK_IMPORTED_MODULE_3__utils_i18n__["b" /* locale */])('step2.server.integration')
          ),
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
            'p',
            { className: '' + __WEBPACK_IMPORTED_MODULE_4__style_css___default.a['sub-txt'] },
            Object(__WEBPACK_IMPORTED_MODULE_3__utils_i18n__["b" /* locale */])('step2.server.desc'),
            ' ',
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
              'a',
              {
                className: 'primary',
                target: '_blank',
                rel: 'noopener noreferrer',
                href: 'https://developer.paytm.com/docs/blink-checkout/'
              },
              'Developer Portal'
            )
          )
        ),
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(__WEBPACK_IMPORTED_MODULE_5__button__["a" /* default */], { onButtonClick: this.onTestIntigration.bind(this), name: Object(__WEBPACK_IMPORTED_MODULE_3__utils_i18n__["b" /* locale */])('checkout.get.api') })
      )
    );
  };

  return CodeIntegration;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

/* harmony default export */ __webpack_exports__["default"] = (Object(__WEBPACK_IMPORTED_MODULE_1_unistore_preact__["connect"])('isGenerateCodeStepEnabled', null)(CodeIntegration));

/***/ }),

/***/ "IOev":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("lcwS")(false);
// imports


// module
exports.push([module.i, "._zR2M{margin-bottom:48px;margin-top:32px}._MPvx{max-width:560px}._3tpB{margin-top:30px}._1FEL,._330i{font-size:14px;line-height:20px;color:#536e92}._330i{margin:4px 0 16px}._9aye{font-size:12px;line-height:16px;color:#182233;margin:0}._3pKq{font-weight:700}._1FEL{padding:6px 16px;display:inline-block;margin-top:24px;cursor:pointer}._1FEL,._255m{border:1px solid #e6ebf3}._255m{position:relative;padding-bottom:55px}._8znW{position:absolute;left:16px;bottom:16px}._3QnS{padding:12px;border-radius:2px;overflow:scroll}._1yn-{vertical-align:middle;margin-right:4px}._2uIp{opacity:0;display:none;font-size:14px;line-height:20px;background:#536e92;color:#fff;padding:6px 16px;border:1px solid #536e92;display:inline-block;margin:24px 0 0 20px;border-radius:4px;-webkit-transform:scale(0);-ms-transform:scale(0);transform:scale(0)}._4ZrH{opacity:1;-webkit-transform:scale(1);-ms-transform:scale(1);transform:scale(1);display:inline-block;-webkit-transition:all .4s ease;transition:all .4s ease}", ""]);

// exports
exports.locals = {
	"code-int": "_zR2M",
	"code-inner": "_MPvx",
	"ser-int": "_3tpB",
	"sub-txt": "_330i",
	"copy-code": "_1FEL",
	"code-txt": "_9aye",
	"bold": "_3pKq",
	"code-block-wrap": "_255m",
	"code-btn-block": "_8znW",
	"code-block": "_3QnS",
	"copy-icon": "_1yn-",
	"code-copied": "_2uIp",
	"copied": "_4ZrH"
};

/***/ }),

/***/ "NZ8y":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("IOev");
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__("BMrJ")(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--4-2!../../../../../node_modules/postcss-loader/lib/index.js??postcss!./style.css", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--4-2!../../../../../node_modules/postcss-loader/lib/index.js??postcss!./style.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ })

});


// WEBPACK FOOTER //
// 3.chunk.ad56f.js